<template>
  <v-card>
    <v-toolbar
      dense
      flat
    >
      Options
      <v-spacer />
      <v-btn
        flat
        small
        @click="importOptionList = true"
      >
        Import Options
      </v-btn>
    </v-toolbar>
    <Draggable
      v-model="optionsList"
      draggable=".draggable-item"
      handle=".handle"
      :animation="150"
      easing="cubic-bezier(1, 0, 0, 1)"
      element="ul"
      style="padding-left:0;margin-bottom:5px;"
    >
      <li
        v-for="(option, index) in optionsList"
        :key="index"
        class="list-item draggable-item"
      >
        <div v-if="editingOptionIndex !== index">
          <a
            roll="button"
            class="handle"
            style="float:left;"
          >
            <v-icon small left>drag_handle</v-icon> 
          </a>
          {{ option.text }}
          <span
            v-if="viewIdentifiers"
            style="padding-left:20px;font-family:monospace;font-size:10px"
          >
            A-{{option.id}}
          </span>
          <a
            roll="button"
            style="float:right;"
            @click="editingOptionIndex=index"
          >
            <v-icon
              small
              color="blue"
            >
              edit
            </v-icon>
          </a>
        </div>
        <div v-if="editingOptionIndex === index">
          <v-text-field
            v-model="optionsList[index].text"
            autofocus
            style="display:inline-block;"
            label="Option"
            hide-details
          />
          <v-btn
            small
            color="blue"
            dark
            @click="editingOptionIndex = null"
          >
            Done
          </v-btn>
        </div>
      </li>
      <li
        slot="footer"
        class="list-item"
      >
        <v-text-field
          v-model="newOption"
          autofocus
          style="display:inline-block;"
          label="Option"
          hide-details
          v-on:keyup.enter="addNewOption"
        />
        <v-btn
          small color="white"
          @click="addNewOption"
        >
          Add Option
        </v-btn>
      </li>
    </Draggable>
    <v-dialog
      v-model="importOptionList"
      width="500"
    >
      <OptionListImporter
        @cancel="importOptionList = false"
        @save="importOpts($event)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import Draggable from 'vuedraggable'
import api from '@/api'
import OptionListImporter from './OptionListImporter'

export default {
  name: 'OptionListBuilder',
  props: [ 'value', 'questionId', 'fieldTypeId' ],
  components: {
    Draggable,
    OptionListImporter
  },
  data () {
    return {
      optionsList: [ ],
      newOption: '',
      editingOptionIndex: null,
      importOptionList: false
    }
  },
  created () {
    if (this.value) {
      this.fetch()
    }
  },
  watch: {
    value: function () {
      api.formtemplate.optionList.get(this.value)
        .then(optionList => {
          this.optionsList = optionList.options
          this.optionList = optionList.id
        })
    },
    editingOptionIndex () {
      if (this.editingOptionIndex !== null) {
        this.$emit('changed')
      }
    }
  },
  computed: {
    ...mapState('formtemplate', [
      'viewIdentifiers'
    ]),
  },
  methods: {
    fetch () {
      this.$emit('loading', true)
      api.formtemplate.optionList.get(this.value)
        .then(optionList => {
          this.optionsList = optionList.options
          this.$emit('loading', false)
        })
    },
    addNewOption () {
      this.optionsList.push({ text: this.newOption })
      this.newOption = ''
      this.$emit('changed')
    },
    importOpts (opts) {
      opts.forEach((o) => {
        this.optionsList.push({ text: o })
      })
      this.importOptionList = false
    },
    save () {
      this.$emit('loading', true)
      return api.formtemplate.optionList.save({
        id: this.value,
        options: this.optionsList
      })
        .then(optionList => {
          this.$emit('input', optionList.id)
        })
    }
  }
}
</script>

<style scoped>
.list-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
</style>
